import React from 'react'
import SchoolMyCourses from '../../features/school/SchoolMyCourses'

const SchoolMyCoursesPage = () => {
    return (
        <SchoolMyCourses />
    )
}

export default SchoolMyCoursesPage
